var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultCustomerLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 24C46 30.9714 42.7574 37.1854 37.6979 41.216C33.9399 44.2108 29.1788 46 24 46C18.8212 46 14.0601 44.2108 10.3021 41.216C5.24257 37.1854 2 30.9714 2 24C2 11.8499 11.8499 2 24 2C36.1501 2 46 11.8499 46 24Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 28C29.1944 28 33 24.1944 33 19.5C33 14.8056 29.1944 11 24.5 11C19.8056 11 16 14.8056 16 19.5C16 24.1944 19.8056 28 24.5 28Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6976 41.216C33.9396 44.2108 29.1784 46 23.9997 46C18.8209 46 14.0598 44.2108 10.3018 41.216C12.0807 35.3373 17.5403 31.0575 23.9997 31.0575C30.459 31.0575 35.9186 35.3373 37.6976 41.216Z",
    fill: "#999999"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCustomerLight);
export default __webpack_public_path__ + "static/media/default-customer-light.ad8157399a9089987415d55658cf30da.svg";
export { ForwardRef as ReactComponent };